<div class="content grid-1-auto md3-surface">
	<div class="content">
		<app-calculation-spreadsheet *ngIf="loaded"
		                             [calcId]="ctData.ctID"
		                             [isMGMT]="excSecurity.isFeatured('RCALCTMGMT')"
		                             [isTemplate]="true"

		                             [allowOpen]="true"

		                             [exceljson]="ctData.ctData"
		                             [contextMenueItems]="contextMenueSubitems"

		                             (Save)="calculationSave(false, $event)"
		                             (autoFillColumns)="setAutoFillColumns($event)">
		</app-calculation-spreadsheet>
	</div>

	<!-- Side Bar -->
	<div class="md3-card-on-surface app-height-auto app-drawer" style="overflow: visible;">
		<i class="disabled search-filter-action"></i>
		<i class="search-filter-seperator"></i>
		<i class="fal fa-save search-filter-action"
		   (click)="calculationSave(false)"
		   [class.disabled]="!(VCSpreadsheet?.isDirty || isNew)"
		   [tooltip]="getGlobal('Save')"
		   flow="left">
		</i>
		<i class="fal fa-pencil search-filter-action"
		   (click)="openModalOeCalculationComponent(ctData)"
		   [tooltip]="getGlobal('Edit')"
		   flow="left">
		</i>
	</div>
</div>
